export const prerender = true;
export const trailingSlash = 'always';

import type { LayoutLoad } from './$types.js';
import pageContent from '$locales/en/content.json';

export const load: LayoutLoad = async () => {
  // All JSON files in $locales/en are consdered posts except content.json
  const postModules = import.meta.glob(
    ['./../locales/en/*.json', '!./../locales/en/content.json'],
    { eager: true }
  );

  const posts = Object.keys(postModules)
    .map((id) => postModules[id].default.story)
    .filter((d) => !!d.slugTitle)
    .reverse();

  return { posts, content: pageContent.story };
};
